import Checkbox from "$lib/components/ui/Checkbox.svelte";
import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
import EditButton from "$lib/components/ui/EditButton.svelte";
import type {Employee} from "$lib/types/employee";

export const mailTemplateLevels = [
    { value: 'system', name: 'System', stati: [] },
    { value: 'candidate', name: 'Bewerber', stati: ['candidate', 'interviewee', 'telephone-interview', 'data-requested', 'date-provided', 'data-verified', 'training-session', 'training-verified'] },
    { value: 'contractible', name: 'MA Vertragsfähig', stati: ['offered', 'onboarding', 'rebuddy', 'data-re-requested', 'data-re-provided', 're-offered', 'inactive'] },
    { value: 'active', name: 'Aktive Mitarbeiter', stati: ['active']},
    { value: 'retiring', name: 'Auflösung/Kündigung', stati: ['active', 'inactive']},
    { value: 'customer', name: 'Kunde', stati: []},
    { value: 'import', name: 'Immer & Import', stati: ['*']},
]



export let mailTemplates = (toggleModal:Function, toggleDelete:Function): Array<SortableTableHeaderElement> => ([
    {
        label: 'Name',
        property: 'name',
        sortable: true
    },
    {
        label: 'Verfügbarkeit',
        property: 'level',
        render: (item:any) => mailTemplateLevels.find(x => x.value === item.level)?.name || item.level
    },
    {
        label: 'Platzhalter',
        property: 'placeholders',
        render: (item:any) => `<p class="max-w-[400px] whitespace-normal">${item.placeholders.map((x:any) => x.templateProperty).join(', ')}</p>` ,
        class: 'w-1/4'
    },
    {
        label: 'Delete',
        property: 'id',
        component: RemoveButton,
        props: {
            onClick: (id:number) => {
                toggleDelete(id)
            },
            classes: 'text-center'
        }
    },
    {
        label: 'Edit',
        property: 'id',
        component: EditButton,
        props: {
            onClick: (id:number) => {
                toggleModal(id)
            },
            classes: 'text-center'
        },
        class: 'w-8'
    }

])